import { ACCEPT_ATTR } from "@/hooks/use-upload";

/** True on touch devices (phones/tablets). */
export function isCoarsePointer(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(pointer: coarse)").matches
  );
}

/** The value for a file picker's `accept` attribute.
 *
 * On desktop we constrain to the exact set the backend can parse. On mobile we
 * deliberately DROP the filter: iOS/Android map `accept` extensions to UTIs and
 * grey out anything they don't recognise — a long, code-heavy list there makes
 * the native picker (and cloud providers like iCloud Drive / Google Drive /
 * Dropbox surfaced through it) reject everything. `useUpload` already validates
 * and warns after selection, so an unfiltered picker is both safe and usable. */
export function uploadAccept(): string | undefined {
  return isCoarsePointer() ? undefined : ACCEPT_ATTR;
}
